<template>
  <div class="animated fadeIn">
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col cols="12" class="">
          <!-- header -->
          <b-card class="border-0">
            <div class="card-text pb-0">
              <div class="d-flex flex-row justify-content-start">
                <div class="text-dark mr-3">
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M24 1h-24v16.981h4v5.019l7-5.019h13z"/></svg></div>
                <div class="h4 font-weight-bold text-dark">Chat</div>
              </div>
            </div>
          </b-card>
          <b-card class="border-0">
            <div class="card-text">
              <div style="overflow:scroll !important; -webkit-overflow-scrolling: touch !important;">
                <b-embed type="iframe"  :src="url"  style="-webkit-overflow-scrolling: touch;overflow-y: scroll;min-height: 700px; min-width: 100%;height: 800px;"  ></b-embed>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </b-container>
  </div>
</template>
<script>
import Message from './Message'
import creditchecklist from './CreditcheckList'
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
export default {
  components: {
    Message,
    creditchecklist,
    loading,
    Simplert
  },
  created () {
    this.Reload()
  },
  data () {
    return {
      emails: [],
      sends: [],
      starMessage: '',
      url: '',
      load: 0,
      cid: '',
      message: '',
      email: '',
      emailShow: false,
      showDismissibleAlert: false,
      formShow: false,
      isLoadingReview: false,
      overlay: true,
      show: false,
      label: 'Loading..'
    }
  },
  methods: {
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.cid = this.$route.query.id
      var data = {operation: 'oversigt_chat', cid: this.cid, salesPerson: this.salesPerson}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.url = 'https://www.kundematch.dk/newchat/?user=' + res.user + '&token=' + res.token + '&dialog=' + res.dialog
          },
          response => {
            alert('error')
          }
        )
    }
  }
}
</script>


// WEBPACK FOOTER //
// Chat.vue?56755885